import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Account } from '../../.types/interfaces/account';

@Injectable({ providedIn: 'root' })
export class AccountSelectService {
  public accounts: Account[] = [];
  public selectedAccount!: Account;

  constructor(private http: HttpClient) {    
  }

  public hasSelectedAccount() {
    if (this.selectedAccount && Object.keys(this.selectedAccount).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  public getSelectedAccount() {
    return this.selectedAccount;
  }

  setSelectedAccount(account: Account) {
    this.selectedAccount = account;
  }

  loadAccountsObservable(username: string): Observable<any[]> {
    const params = new HttpParams()
      .set('username', username)
      .set('viewname', 'my-account');

    const results = this.http.get<any[]>('/api/cinchusers', {params: params});
    
    return results;
  }

  public reset() {
    this.accounts = [];
    this.selectedAccount = {} as Account;
  }
}